import {connect, useSelector} from "react-redux";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormInput, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import {Loading} from "../../../components/common";
import {AgGridReact} from "ag-grid-react";
import StoreListWhere from "../where/StoreListWhere";
import * as o2Api from "../../../api/api";
import StoreCornerListWhere from "../where/StoreCornerListWhere";


const StoreCopy = (props) => {
    const {user} = useSelector((props) => props.account);

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [display, setDisplay] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]);
    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "", cornerCd: ""
    });

    const [origStoreInfo, setOrigStoreInfo] = useState({
        origCmpCd: "", origBrandCd: "", origStoreCd: "", origBrandNm: "", origStoreNm: ""
    });
    const [copyStoreInfo, setCopyStoreInfo] = useState({
        copyCmpCd: "", copyBrandCd: "", copyStoreCd: "", copyBrandNm: "", copyStoreNm: ""
    });

    const [selectProduct, setSelectProduct] = useState({});
    const [selectNationCd, setSelectNationCd] = useState("US");
    const [selectProductInfo, setSelectProductInfo] = useState({seq:0, productNm: "", origin: "", nutrient: "", nationCd: "US"});

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "seq", headerName: "seq", hide:true},
        {field: "cmpCd", headerName: "운영사코드", width: 120,hide:true},
        {field: "cmpNm", headerName: "운영사", width: 140,hide:true},
        {field: "brandCd", headerName: "휴게소코드", width: 100},
        {field: "brandNm", headerName: "휴게소", width: 140},
        {field: "storeCd", headerName: "매장코드", width: 100},
        {field: "storeNm", headerName: "매장명", width: 140},
        {field: "ownerNm", headerName: "대표자명", width: 90},
        {field: "useYn", headerName: "상태", width: 70}
    ]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    const search = async () => {
        setError({visible: false, message: ""});
        const {cmpCd, brandCd, storeCd} = searchForm;
        if (cmpCd.length === 0) {
            setError({
                visible: true,
                message: "운영사 정보를 선택해주세요."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            userId: user.userId,
            manageDiv: "0"
        };

        setLoading(true);
        o2Api.getStoreWhere(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log(">>> response :: ", responseBody);
                // 성공
                setGridData(responseBody);
            }
        })
            .finally(() => {
                setLoading(false);
            })
    };


    const selectOrigStore = async () => {

        const { api } = gridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();
        console.log("selectRows::", selectRows);

        setOrigStoreInfo({
            origCmpCd: selectRows[0].cmpCd,
            origBrandCd: selectRows[0].brandCd,
            origStoreCd: selectRows[0].storeCd,
            origBrandNm: selectRows[0].brandNm,
            origStoreNm: selectRows[0].storeNm
        });

    }

    const selectCopyStore = async () => {
        const { api } = gridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();
        console.log("selectRows::", selectRows);

        setCopyStoreInfo({
            copyCmpCd: selectRows[0].cmpCd,
            copyBrandCd: selectRows[0].brandCd,
            copyStoreCd: selectRows[0].storeCd,
            copyBrandNm: selectRows[0].brandNm,
            copyStoreNm: selectRows[0].storeNm
        });

    }

    const save = async () => {

        const storeCopyData = {
            origCmpCd: origStoreInfo.origCmpCd,
            origBrandCd: origStoreInfo.origBrandCd,
            origStoreCd: origStoreInfo.origStoreCd,
            copyCmpCd: copyStoreInfo.copyCmpCd,
            copyBrandCd: copyStoreInfo.copyBrandCd,
            copyStoreCd: copyStoreInfo.copyStoreCd,
            updUser: user.userId,
        }

        if(storeCopyData.origStoreCd.length === 0){
            alert("원본 점포를 선택해주세요.");
            return;
        }
        if(storeCopyData.copyStoreCd.length === 0){
            alert("복사할 점포를 선택해주세요.");
            return;
        }

        if (confirm("저장하시겠습니까?")) {
            // 저장 파라메터 생성

            console.log(">>> params :: ", storeCopyData);

            setLoading(true);

            o2Api.updateStoreDataCopy(storeCopyData).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    // 성공
                    alert("정상적으로 처리되었습니다.");
                    // search();
                } else {
                    setError({visible: true, message: responseMessage});
                }
            })
                .catch((e) => {
                    setError({visible: true, message: e.message});
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    const getProductInfoOne = (productCd, nationCd) => {
        const params = {
            productCd: productCd,
            nationCd: nationCd
        };
        setLoading(true);
        getCkProductInfoOne(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                // 성공
                if (responseBody === null) {
                    setSelectProductInfo({productNm: "", origin: "", nutrient: "", nationCd: "US"});
                }
                else {
                    setSelectProductInfo(responseBody);
                }
            } else {
                setError({visible: true, message: responseMessage});
            }
        })
            .catch((e) => {
                setError({visible: true, message: e.message});
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const onRowSelected = useCallback((event) => {
        if (!event.node.selected)
            return;

        // 이전 값 초기화
        setSelectProductInfo({productNm: "", origin: "", nutrient: "", nationCd: "US"});

        const data = event.node.data;
        setSelectProduct(data);
        setSelectNationCd("US");
        getProductInfoOne(data.productCd, "US");
    }, []);

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                {loading ? <Loading/> : null}

                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                    <h5>점포 환경설정 복사</h5>
                </div>

                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                    <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                                    onSelect={(c, v) => handleSelect(c, v)}/>
                    <CCol xs={12}>
                        <CButton size={"sm"} onClick={search}>조회</CButton>
                    </CCol>
                </CForm>

                <div style={{height: 10}}/>
                <CRow>
                    <CCol xs={6}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            <strong>점포목록</strong>
                        </div>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
                            <AgGridReact
                                ref={gridRef}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={gridData}
                                //animateRows={true}
                                rowSelection={'single'}
                                //onRowSelected={onRowSelected}
                                defaultColDef={defaultColDef}
                                columnDefs={columnDefs}>
                            </AgGridReact>
                        </div>
                    </CCol>
                    <CCol xs={6}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            <strong>원본 점포</strong>
                        </div>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>휴게소명</strong></CInputGroupText>
                            <CFormInput id="restProductCd"
                                        value={origStoreInfo.origBrandNm}
                                        disabled={true}/>
                        </CInputGroup>

                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>점포명</strong></CInputGroupText>
                            <CFormInput id="productNm"
                                        value={origStoreInfo.origStoreNm}
                                        disabled={true}/>
                        </CInputGroup>
                        <input type="hidden" value={origStoreInfo.origCmpCd} />
                        <input type="hidden" value={origStoreInfo.origBrandCd} />
                        <input type="hidden" value={origStoreInfo.origStoreCd} />

                        <div className={"d-grid"} style={{marginTop: 10}}>
                            <CButton onClick={selectOrigStore}>원본점포 선택</CButton>
                        </div>

                        <div style={{
                            borderRadius: 5,
                            padding: 10,
                            marginTop: 10,
                            marginBottom: 10,
                            background: "#87CEFA"
                        }}>

                        <strong>복사할 점포</strong>
                        </div>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>휴게소명</strong></CInputGroupText>
                            <CFormInput id="restProductCd"
                                        value={copyStoreInfo.copyBrandNm}
                                        disabled={true}/>
                        </CInputGroup>

                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>점포명</strong></CInputGroupText>
                            <CFormInput id="productNm"
                                        value={copyStoreInfo.copyStoreNm}
                                        disabled={true}/>
                        </CInputGroup>
                        <input type="hidden" value={copyStoreInfo.copyCmpCd} />
                        <input type="hidden" value={copyStoreInfo.copyBrandCd} />
                        <input type="hidden" value={copyStoreInfo.copyStoreCd} />

                        <div className={"d-grid"} style={{marginTop: 10}}>
                            <CButton onClick={selectCopyStore}>복사할 점포 선택</CButton>
                        </div>

                        <div className={"d-grid"} style={{marginTop: 10}}>
                            <CButton onClick={save}>저장</CButton>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(StoreCopy);
